export const EnumMaintenance = Object.freeze({

    SHEPHERD: 701,

})